import React, { useContext } from 'react'

import { VenueMapComponent } from '@vividseats/venue-maps-component'

import '@vividseats/venue-maps-component/dist/components/VenueMap/vivid-override.css'
import ClearSectionsButton from '@/components/shared/map/components/clear-sections-button'
import MapContext from '@/context/map'

import filterContext from '../context'
import ProductionFooter from '../footer'

import styles from './styles.module.scss'

type MapboxMapPropTypes = {
    displayFooter?: boolean
}

const MapboxMap = (props: MapboxMapPropTypes) => {
    const { displayFooter } = props
    const {
        selectors: { venueMapState },
    } = useContext(MapContext)
    const { mapElement } = venueMapState

    const {
        selectors: { getHighlightedSections, getHighlightedRows },
        dispatch: { onResetSectionSelectionAction },
    } = useContext(filterContext)

    return (
        <>
            {(getHighlightedSections.length >= 1 || !!getHighlightedRows.length) && (
                <div className={styles.mapControlsContainer} data-testid="map-controls-container">
                    <ClearSectionsButton
                        onClick={() => {
                            onResetSectionSelectionAction()
                        }}
                    />
                </div>
            )}
            <VenueMapComponent mapElement={mapElement} />
            {displayFooter && <ProductionFooter renderOnDesktop open />}
        </>
    )
}

export default MapboxMap
